namespace $.$$ {
	$mol_style_define($shm_paginator, {
		flex: {wrap: 'wrap'}, alignItems: 'center', justifyContent: 'flex-start',
		Numbers: {flex: {wrap: 'wrap'}, alignItems: 'center'},
		Info: {alignItems: 'center', color: $mol_theme.shade},
		Gap: {alignItems: 'center', color: $mol_theme.shade},
		Button: {'[aria-current]': {page: {color: $mol_theme.current}}},
	})
}
